export class SmartSlider extends HTMLElement {
  connectedCallback() {
    const scriptTag = this.querySelector('script[type="application/json"]');
    const jsonString = scriptTag ? scriptTag.textContent.trim() : null;
    this.config = jsonString ? JSON.parse(jsonString) : {};

    const swiperEl = this.querySelector('.swiper');

    if (swiperEl) {
      new Swiper(swiperEl, this.config);
    }
  }
}

customElements.define('smart-slider', SmartSlider);
